import { mixpanel } from '@fiverr-private/obs';
import {
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
} from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';
import { getStepReport } from '../../utils/getStepReport';

export const reportNavigatedBack = (stepIndex: number) => {
    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, {
        ...getDataFromStores(store.pagePath, store.brief),
        ...getStepReport(stepIndex),
        [MIXPANEL_EVENT_PROPERTIES.ACTION]: 'Navigated Back',
    });
};
